import React, { useState } from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import HowItWorksSection from "./HowItWorksSection";
import BenefitsSection from "./BenefitsSection";
import ApplicationForm from "./ApplicationForm";
import FAQSection from "./FAQSection";
import Footer from "./Footer";
import { mockData } from "../data/mock";

const LandingPage = () => {

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <AboutSection data={mockData.about} />
      <HowItWorksSection data={mockData.howItWorks} />
      <BenefitsSection data={mockData.benefits} />
      <ApplicationForm />
      <FAQSection data={mockData.faq} />
      <Footer />
    </div>
  );
};

export default LandingPage;